import { render } from "./Teachers.vue?vue&type=template&id=403ba530"
import script from "./Teachers.vue?vue&type=script&lang=js"
export * from "./Teachers.vue?vue&type=script&lang=js"

import "./Teachers.vue?vue&type=style&index=0&id=403ba530&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__